const actionTypeConstants = {
    UPDATE_USER: "UPDATE_USER",
    UPDATE_HISTORY_INDEX: "UPDATE_HISTORY_INDEX",
    UPDATE_PAGE_COUNT: "UPDATE_PAGE_COUNT",
    INIT: "INIT",
    STORE_SIGNATURES_API: "STORE_SIGNATURES_API",
    UPDATE_ACCEPT_PAYMENT_DETAILS: "UPDATE_ACCEPT_PAYMENT_DETAILS",
    UPDATE_BOL_DETAILS: 'UPDATE_BOL_DETAILS',
    BOL_DATA:'BOL_DATA',
    UPDATE_CUSTOMER_INFO:'UPDATE_CUSTOMER_INFO',
    BOL_NO:'BOL_NO',
    USER_READ_TERMS_CONDITIONS: 'USER_READ_TERMS_CONDITIONS',
    UPDATE_VALUATION_DETAILS: 'UPDATE_VALUATION_DETAILS',
    UPDATE_SHIPMENT_VALUE: 'UPDATE_SHIPMENT_VALUE',
    DEFAULT_SHIPMENT_VALUE: 'DEFAULT_SHIPMENT_VALUE',
    UPDATE_DEDUCTIBLE_OPTIONS: 'UPDATE_DEDUCTIBLE_OPTIONS',
    UPDATE_VALUATION_DECLARATION: 'UPDATE_VALUATION_DECLARATION',
    SELECTED_VALUATION_OPTIONS: 'SELECTED_VALUATION_OPTIONS',
    SHOW_MESSAGE: 'SHOW_MESSAGE',
    HIDE_MESSAGE: 'HIDE_MESSAGE',
    EXTRA_ORDINARY_ACCEPT_SIGN: 'EXTRA_ORDINARY_ACCEPT_SIGN',
    MOVE_DETAILS_ACCEPT_SIGN: 'MOVE_DETAILS_ACCEPT_SIGN',
    TERMS_AND_CONDITIONS_ACCEPT_SIGN: 'TERMS_AND_CONDITIONS_ACCEPT_SIGN',
    PICKUP_AUTH_ACCEPT_SIGN: 'PICKUP_AUTH_ACCEPT_SIGN',
    UPDATE_SELECTED_OPTIONS_DATA:'UPDATE_SELECTED_OPTIONS_DATA',
    UPDATE_BACK_LINK: 'UPDATE_BACK_LINK',
    SHIPPER_DECLARED_VALUE: 'SHIPPER_DECLARED_VALUE'
}

export default actionTypeConstants;